module.exports = __webpack_public_path__ + "static/Resin Veneers smile after-7dd4dc49ddb56527f8aca33b8b04262c.jpg";